import importerActions from 'modules/shared/importer/importerActions';
import selectors from 'modules/group/importer/groupImporterSelectors';
import GroupService from 'modules/group/groupService';
import fields from 'modules/group/importer/groupImporterFields';
import { i18n } from 'i18n';

export default importerActions(
  'GROUP_IMPORTER',
  selectors,
  GroupService.import,
  fields,
  i18n('entities.group.importer.fileName'),
);
